import React from 'react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://7vtxaf-x1.myshopify.com/cart/45821756342458:1';
export function Closing() {
  return <section className="w-full bg-black text-white py-20 md:py-32 px-4" data-id="element-22">
      <div className="max-w-4xl mx-auto text-center" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-24">
          <h2 className="text-5xl md:text-7xl font-black mb-12" data-id="element-25">
            No es motivación.
            <br data-id="element-26" />
            Es <span className="text-yellow-400" data-id="element-27">sistema</span>.
          </h2>

          <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold text-2xl md:text-3xl px-16 py-8 rounded-xl shadow-2xl transition-all duration-300 w-full md:w-auto" data-id="element-28">
            EMPEZAR HOY
          </motion.a>
        </motion.div>
      </div>
    </section>;
}